import { createLegacyEnvConfig, Environment, ServicesOrchestrator } from "@pandas/constants";
import { z } from "zod";

export const appEnvSchema = z.object({
	VITE_APP_NAME: z.string().default("retail-app"),
	VITE_APP_VERSION: z.string().default("0.0.0"),
	VITE_APP_ENV: z.enum(Environment).optional(),
	VITE_SIMPLELOCALIZE_BASE_URL: z.string().default("https://cdn.simplelocalize.io"),
	VITE_SIMPLELOCALIZE_PROJECT_TOKEN: z.string(),
	VITE_SIMPLELOCALIZE_ENV: z.string(),
	VITE_GOOGLE_TAG_MANAGER_ID: z.string().default("GTM-W6D96NS"),
	VITE_AUTH0_DOMAIN: z.string(),
	VITE_AUTH0_CLIENT_ID: z.string(),
	VITE_AUTH0_AUDIENCE: z.string().optional(),
});

const commonEnv = createLegacyEnvConfig(import.meta.env);
const appEnv = appEnvSchema.parse(import.meta.env);

const orchestrator = new ServicesOrchestrator({ env: commonEnv });

export const servicesOrchestratorValues = {
	app: {
		name: appEnv.VITE_APP_NAME,
		version: appEnv.VITE_APP_VERSION,
		env: appEnv.VITE_APP_ENV ?? commonEnv.COMMON_ENV_ENVIRONMENT,
		googleTagManagerId: appEnv.VITE_GOOGLE_TAG_MANAGER_ID,
		simpleLocalizeBaseUrl: appEnv.VITE_SIMPLELOCALIZE_BASE_URL,
	},
	auth0: {
		domain: appEnv.VITE_AUTH0_DOMAIN,
		clientId: appEnv.VITE_AUTH0_CLIENT_ID,
		audience: appEnv.VITE_AUTH0_AUDIENCE,
	},
	environment: orchestrator.environment,
	isProduction: orchestrator.isProduction,
	isUat: orchestrator.isUat,
	isDevelopment: orchestrator.isDevelopment,
	urls: orchestrator.urls,
	credentials: {
		...orchestrator.credentials,
		simpleLocalizeProjectToken: appEnv.VITE_SIMPLELOCALIZE_PROJECT_TOKEN,
		simpleLocalizeEnvironment: appEnv.VITE_SIMPLELOCALIZE_ENV,
	},
} as const;
